module.exports = __webpack_public_path__ + "resources/img/bg_cover_marketplace.f1cf2a1b6b4c4726f75723fb8e85ba87.png";